module.exports = __webpack_public_path__ + "img/Dedication.d4c33408.jpg";